// extracted by mini-css-extract-plugin
module.exports = {"btn":"btn_btn_267Jb","active":"btn_active_Wk50y","plain":"btn_plain_3DCoL","disabled":"btn_disabled_1bpPF"};